import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "./ui/button";

const KEY = "oc_cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setOpen(true);
  }, []);

  const accept = (mode) => {
    localStorage.setItem(KEY, JSON.stringify({ mode, ts: Date.now() }));
    // Convenience flag for PixelInjector — only injects marketing pixels when 'all'.
    if (mode === "all") localStorage.setItem("oc_marketing_consent", "1");
    else localStorage.removeItem("oc_marketing_consent");
    setOpen(false);
    // Reload so PixelInjector picks up the new consent state immediately.
    if (mode === "all") setTimeout(() => window.location.reload(), 100);
  };

  if (!open) return null;
  return (
    <div
      data-testid="oc-cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-white rounded-oc shadow-oc-card-hover border border-oc-border p-6"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-oc-subtle flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5 text-oc-primary" strokeWidth={2} />
        </div>
        <div className="flex-1">
          <h4 className="font-display font-semibold text-oc-primary text-base mb-1">
            We respecteren je privacy
          </h4>
          <p className="text-[14px] text-oc-textSecondary leading-relaxed">
            We gebruiken cookies om je ervaring te verbeteren en anonieme statistieken bij te houden. Lees ons {" "}
            <Link to="/cookiebeleid" className="underline text-oc-secondary hover:text-oc-primary">cookiebeleid</Link>.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <Button
              data-testid="cookie-accept-all"
              onClick={() => accept("all")}
              className="bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn h-10 px-5 text-[14px] font-semibold"
            >
              Alles accepteren
            </Button>
            <Button
              data-testid="cookie-essential"
              onClick={() => accept("essential")}
              variant="outline"
              className="rounded-oc-btn h-10 px-5 border-oc-border text-oc-primary hover:bg-oc-subtle text-[14px] font-semibold"
            >
              Enkel noodzakelijk
            </Button>
          </div>
        </div>
        <button
          aria-label="Sluiten"
          className="text-oc-textSecondary hover:text-oc-primary"
          onClick={() => accept("essential")}
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
